export class SetCurrentIndexPageAction {
  static readonly type = '[Page] Set current index page';
  constructor(public pageIndex: number) {}
}
